module.exports = __webpack_public_path__ + "static/media/3DPPA9.27c3a44c.jpg";